import { useErrors } from '@auth0/auth0-acul-react/mfa-email-challenge';
import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import InfoBlock3 from 'creative-ui/uikit/InfoBlock3';
import SvgCheckMark from 'creative-ui/uikit/svg/check-mark';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AuthErrorBanner } from '@/components/AuthErrorBanner/AuthErrorBanner';
import ContactAdvisorModal from '@/components/ContactAdvisorModal/ContactAdvisorModal';
import { useTrackErrors } from '@/hooks/useTrackErrors';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { commonTransComponents } from '@/i18n/translationsComponents';
import { trackPageView } from '@/lib/tagging';

import MfaEmailChallengeForm from './components/MfaEmailChallengeForm';
import { useMfaEmailChallengeManager } from './hooks/useMfaEmailChallengeManager';

function MfaEmailChallengeScreen() {
  const { t } = useTranslation('mfaEmailChallenge');
  useTransactionLocale();

  const { email } = useMfaEmailChallengeManager();

  const { errors } = useErrors();
  const { generalErrorMessages, fieldErrors } = useTrackErrors(
    errors,
    'login/email/code/error',
  );

  useEffect(() => {
    trackPageView('login/email/code');
  }, []);

  document.title = t('page.title');

  const title = t('header.title');
  const codeSentTitle = t('header.codeSentTitle');
  return (
    <BaseWrapper title={title}>
      <InfoBlock3
        className="u-margin-b-l"
        title={codeSentTitle}
        color="green"
        svgComp={SvgCheckMark}
        box
        border>
        <Trans
          i18nKey="header.codeSentMessage"
          t={t}
          values={{ email }}
          components={commonTransComponents}
        />
      </InfoBlock3>
      <AuthErrorBanner errors={generalErrorMessages} />
      <MfaEmailChallengeForm fieldErrors={fieldErrors} />
      <ContactAdvisorModal
        className="u-margin-t-l"
        ctaLabel={t('modalContact.ctaLabel')}
      />
    </BaseWrapper>
  );
}

export default MfaEmailChallengeScreen;
